<template>
  <section :aria-label="`Detalhes do item: ${product.title}`">

    <div class="flex flex-col items-start justify-start w-full px-8 py-4 font-normal text-gray-800 bg-white border rounded-lg shadow-md">
      <div class="flex flex-col items-stretch justify-start w-full h-auto space-y-2 sm:space-y-0 md:flex-row md:items-start md:justify-between">

        <h1 class="block text-xl sm:hidden text-purple-mobly">
          {{ product.title }}
        </h1>

        <div class="flex flex-row items-start justify-start flex-1 h-auto space-x-2">
          <div class="w-20 h-20 md:w-48 md:h-48 sm:w-36 sm:h-36 ">
            <ImgLoadImage
              :src="product.image"
              :alt="product.title"
              :extra-classes="'h-auto'"
            />
          </div>

          <div class="flex flex-col items-start justify-start flex-1">
            <h1 class="hidden text-xl sm:block text-purple-mobly">
              {{ product.title }}
            </h1>
            <table>
              <tr class="leading-6">
                <td>
                  Valor do item:
                </td>
                <td class="pl-2 font-semibold">
                  {{ product.invoiceData.unitAmount | formatCurrency }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Desconto:
                </td>
                <td class="pl-2 font-semibold">
                  {{ product.invoiceData.discountAmount | formatCurrency}}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Valor do frete:
                </td>
                <td class="pl-2 font-semibold">
                  {{ product.invoiceData.shippingAmount | formatCurrency }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Vendido e entregue por:
                </td>
                <td class="pl-2 font-semibold">
                  {{ product.supplier }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Serviço de montagem:
                </td>
                <td class="pl-2 font-semibold">
                  {{ product.assembly.hasInstallation ? 'Sim' : 'Não contratado' }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Quantidade:
                </td>
                <td class="pl-2 font-semibold">
                  {{ product.quantity }}
                </td>
              </tr>
              <tr class="leading-6">
                <td>
                  Previsão de Entrega:
                </td>
                <td class="pl-2 font-semibold">
                  {{ getDeliveryDays(product) }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="flex flex-row items-start justify-center w-full h-auto mt-3 md:block md:w-60 md:ml-8">
          <SimpleTimeLine :timeline="product.timelineMos" />
        </div>

      </div>

      <router-link
        class="block mt-4 appearance-none align-self-sm-end align-self-stretch focus:outline-none focus:ring-0 focus:ring-transparent hover:no-underline"
        :to='`${$route.path}/timeline?item=${product.id}`'
      >
        <button class="flex items-center justify-center w-full px-20 py-2 font-semibold transition-colors appearance-none text-md flex-nowrap text-purple-mobly hover:text-purple-mobly-dark active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent hover:no-underline">
          <span>Ver mais detalhes</span>
        </button>
      </router-link>

      <hr class="w-full mt-4 mb-2 border-2" />

      <h2 class="text-xl text-gray-800">
        Precisa de ajuda sobre este item?
      </h2>

      <div class="flex flex-col items-stretch justify-start w-full sm:flex-row sm:flex-wrap sm:items-center sm:justify-start text-purple-mobly">

        <button
          v-if="showButton(clusters, productStatus, 'downloadManual')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openManual(product.manual)"
        >
          <DownloadIcon class="relative w-5 h-5 top-px" />
          <span>Manual de montagem</span>
        </button>

        <button
          v-if="showButton(clusters, productStatus, 'helpAssembly')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openModal('helpAssembly')"
        >
          <QuestionMarkCircleIcon class="relative w-5 h-5 top-px"/>
          <span>Serviço de montagem</span>
        </button>

        <button
          v-if="showButton(clusters, productStatus, 'helpDelivery')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openModal('helpDelivery')"
        >
          <TruckIcon class="relative w-5 h-5 top-px"/>
          <span>Falar sobre a entrega</span>
        </button>

        <button
          v-if="showButton(clusters, productStatus, 'downloadInvoice')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openModal('downloadInvoice')"
        >
          <DocumentTextIcon class="relative w-5 h-5 top-px" />
          <span>Nota fiscal</span>
        </button>

        <button
          v-if="showButton(clusters, productStatus, 'cancelProduct')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openModal('cancelProduct')"
        >
          <XIcon class="relative w-5 h-5 top-px"/>
          <span>Cancelar item</span>
        </button>

        <button
          v-if="showButton(clusters, productStatus, 'helpCancel')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openModal('helpCancel')"
        >
          <QuestionMarkCircleIcon class="relative w-5 h-5 top-px"/>
          <span>Ainda é possível cancelar?</span>
        </button>

        <button
          v-if="showButton(clusters, productStatus, 'helpNotDelivered')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openModal('helpNotDelivered')"
        >
          <ExclamationCircleIcon class="relative w-5 h-5 top-px"/>
          <span>Ajuda sobre a entrega</span>
        </button>

        <button
          v-if="showButton(clusters, productStatus, 'helpExchange')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openModal('helpExchange')"
        >
          <SwitchHorizontalIcon class="relative w-5 h-5 top-px"/>
          <span>Troca ou devolução</span>
        </button>

        <button
          v-if="showButton(clusters, productStatus, 'helpRefund')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openModal('helpRefund')"
        >
          <CurrencyDollarIcon class="relative w-5 h-5 top-px"/>
          <span>Falar sobre reembolso</span>
        </button>

        <button
          v-if="showButton(clusters, productStatus, 'helpGeneral')"
          class="relative flex items-center justify-center px-2 py-2 mt-3 space-x-2 font-semibold transition-colors rounded-md flex-nowrap border-1 border-purple-mobly sm:mr-3 min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark active:border-purple-mobly-light active:text-purple-mobly-light focus:outline-none focus:ring-0 focus:ring-transparent"
          @click="openMoblyFAQ()"
        >
          <QuestionMarkCircleIcon class="relative w-5 h-5 top-px"/>
          <span>Ajuda sobre outro assunto</span>
        </button>
      </div>
    </div>
    <Modal
      :show="modalConfig.showModal"
    >
      <div
        v-if="createTicketLoading || loadingModalWorkflows"
        slot="content"
      >
        <spinner :loading="createTicketLoading || loadingModalWorkflows" />
      </div>
      <div
        v-if="!createTicketLoading && !loadingModalWorkflows"
        slot="content"
      >
        <div
          id="header"
          class="flex items-center justify-between w-full px-3 py-2 text-white border-0 rounded-t bg-purple-mobly"
        >
          <span
            class="text-lg font-semibold"
          >
            {{ modalConfig.modalTitle }}
          </span>

          <button
            class="focus:outline-none focus:ring-0"
            @click="handleModalClose(null)"
          >
          <XIcon class="w-6 h-6"/>

          </button>
        </div>

        <div
          class="flex flex-col items-stretch justify-start px-4 py-10"
        >
        <p class="w-full text-lg font-normal text-left" v-html="modalConfig.modalLabel "></p>
          <div
            v-if="modalConfig && modalConfig.isMulti"
            class="w-full mt-4 space-y-2 text-lg font-normal"
          >
            <div
              v-for="(option, index) of modalConfig.modalOptions"
              :key="index"
              class="flex flex-row items-center justify-start w-full space-x-2"
            >
              <input
                type="radio"
                class="border-gray-500 text-purple-mobly focus:ring-0 active:ring-0"
                :id="`option-${index}`"
                :value="option.public_value"
                v-model="modalConfig.modalValue"
              />
              <label
                class="mb-0"
                :for="`option-${index}`"
              >
                {{ option.public_label }}
              </label>
            </div>
          </div>
          <div class="flex flex-col items-center justify-start w-full mt-8 space-y-3">
            <button
              class="relative flex items-center justify-center px-2 py-2 font-semibold text-white transition-colors rounded-md flex-nowrap min-w-50 bg-purple-mobly hover:bg-purple-mobly-dark hover:text-purple-mobly-dark focus:outline-none focus:ring-0 disabled:opacity-50 disabled:bg-purple-mobly disabled:cursor-not-allowed"
              :disabled="modalConfig.isMulti && modalConfig.modalValue === null"
              @click="handleModalClose(modalConfig.modalValue)"
            >
              {{ modalConfig.modalButtonLabel }}
            </button>
            <button
              v-if="!modalConfig.modalHideCancelButton"
              class="relative flex items-center justify-center px-2 py-2 space-x-2 font-semibold transition-colors bg-white rounded-md text-purple-mobly flex-nowrap border-1 border-purple-mobly min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark focus:outline-none focus:ring-0"
              @click="handleModalClose(null)"
            >
              Voltar
            </button>
          </div>
        </div>
      </div>
    </Modal>

    <Modal :show="openModalAssemblyUrl">
      <div slot="content">
        <div
          id="header"
          class="flex items-center justify-between w-full px-3 py-2 text-white border-0 rounded-t bg-purple-mobly"
        >
          <span
            class="text-lg font-semibold"
          >
            {{ modalConfig.modalTitle }}
          </span>

          <button
            class="focus:outline-none focus:ring-0"
            @click="openModalAssemblyUrl = false"
          >
            <XIcon class="w-6 h-6"/>
          </button>
        </div>

        <div class="flex flex-col items-stretch justify-start px-4 py-10">
          <span class="w-full text-sm italic text-center text-gray-600">Link para agendamento da montagem ainda não disponível</span>
        </div>
        <button
          @click="(openModalAssemblyUrl =  false)" 
          class="relative flex items-center justify-center px-2 py-2 mx-auto mb-4 space-x-2 font-semibold transition-colors bg-white rounded-md text-purple-mobly flex-nowrap border-1 border-purple-mobly min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark focus:outline-none focus:ring-0">
          Fechar
        </button>
      </div>
    </Modal>
    <Modal :show="openModalAssemblyHistory" :maxW="'max-w-3xl'">
      <div slot="content">
        <div
          id="header"
          class="flex items-center justify-between w-full px-3 py-2 text-white border-0 rounded-t bg-purple-mobly"
        >
          <span
            class="text-lg font-semibold"
          >
            Histórico de montagens
          </span>

          <button
            class="focus:outline-none focus:ring-0"
            @click="openModalAssemblyHistory = false"
          >
            <XIcon class="w-6 h-6"/>
          </button>
        </div>

        <div class="flex w-full p-4" v-if="product.assembly.schedule && !product.assembly.schedule.length">
          <span class="w-full text-sm italic text-center text-gray-600">Nenhum histórico encontrado</span>
        </div>
        <div class="w-full p-4 space-y-3 h-96 mb-9" v-else>
          <div class="flex bg-gray-200 py-2 px-1 rounded-md justify-between">
            <div class="space-x-1">
              <span class="font-semibold">Montadora:</span>
              <span class="text-xs">{{ assembler }}</span>
            </div>
            <div class="space-x-1">
              <span class="font-semibold">Data:</span>
              <span class="text-xs">{{ assemblyDate }}</span>
            </div>
          </div>
          <div class="h-full overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 scrollbar-w-thin scrollbar-thumb-rounded">
            <table class="min-w-full p-3 text-sm divide-y-2 divide-gray-200">
              <thead>
                <tr class="text-white bg-purple-mobly-light">
                  <th class="px-4 py-2 text-left whitespace-nowrap rounded-l-md"> Data </th>
                  <th class="px-4 py-2 text-left whitespace-nowrap"> Hora </th>
                  <th class="px-4 py-2 text-left whitespace-nowrap"> Status </th>
                  <th class="px-4 py-2 text-left whitespace-nowrap"> Agendamento </th>
                  <th class="px-4 py-2 text-left whitespace-nowrap"> Horário </th>
                  <th class="px-4 py-2 text-left whitespace-nowrap rounded-r-md"> Tipo do encerramento </th>
                </tr>
              </thead>

              <tbody class="divide-y divide-gray-200">
                <tr
                  v-for="schedule in schedules"
                  :key="schedule.id"
                >
                  <td class="px-4 py-2 text-gray-900 whitespace-nowrap"> {{schedule.date}} </td>
                  <td class="px-4 py-2 font-medium text-gray-700 whitespace-nowrap"> {{schedule.hour}} </td>
                  <td class="px-4 py-2 font-medium text-gray-700 whitespace-nowrap capitalize"> {{schedule.status}} </td>
                  <td class="px-4 py-2 font-medium text-gray-700 whitespace-nowrap"> {{schedule.scheduleDate}} </td>
                  <td class="px-4 py-2 font-medium text-gray-700 whitespace-nowrap"> {{schedule.scheduleTime}} </td>
                  <td class="px-4 py-2 font-medium text-gray-700 whitespace-nowrap capitalize"> {{schedule.closingType}} </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <button
          @click="(openModalAssemblyHistory =  false)" 
          class="relative flex items-center justify-center px-2 py-2 mx-auto mb-4 space-x-2 font-semibold transition-colors bg-white rounded-md text-purple-mobly flex-nowrap border-1 border-purple-mobly min-w-50 hover:border-purple-mobly-dark hover:text-purple-mobly-dark focus:outline-none focus:ring-0">
          Fechar
        </button>
      </div>
    </Modal>
  </section>
</template>

<script>
import { 
  XIcon, 
  TruckIcon, 
  DownloadIcon,
  QuestionMarkCircleIcon,
  DocumentTextIcon,
  ExclamationCircleIcon,
  SwitchHorizontalIcon,
  CurrencyDollarIcon
} from "@vue-hero-icons/solid"
import ImgLoadImage from '@/components/LazyImage/ImgLoadImage'
import SimpleTimeLine from '@/components/Orders/SimpleTimeLine'
import Modal from '@/components/Commons/Modal'
import Spinner from '@/components/Spinner/Spinner'
import {
  PAYMENT_PENDING,
  PAYMENT_NOT_APPROVED,
  PAYMENT_REPROVED,
  IN_PREPARATION_CONFIRMED,
  IN_PREPARATION_AWAITING,
  IN_PREPARATION_RESERVED,
  IN_PREPARATION_BILLED,
  CANCELED,
  FINISHED
} from '@/enum/enum.cluster.status'
import { currencyFormat, dateFormat } from '@/functions'
import { createTicket, checkAutoPop } from '@/repositories/ticket'
import { getFileS3 } from '../../functions'

export default {
  name: 'OrderItemDetail',

  components: {
    XIcon,
    TruckIcon,
    DownloadIcon,
    QuestionMarkCircleIcon,
    DocumentTextIcon,
    ExclamationCircleIcon,
    SwitchHorizontalIcon,
    CurrencyDollarIcon,
    ImgLoadImage,
    SimpleTimeLine,
    Modal,
    Spinner
  },

  props: {
    product: {
      type: Object,
      default: () => {}
    },
    workflowsConfig: {
      type: Array,
      default: () => []
    },
    productsCount: {
      type: Number,
      default: 0
    },
    orderCod: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      clusters: {
        PAYMENT_PENDING,
        PAYMENT_NOT_APPROVED,
        PAYMENT_REPROVED,
        IN_PREPARATION: 'inPreparation',
        CANCELED,
        FINISHED,
        IN_PROGRESS: 'inProgress',
        INVALID: 'invalid'
      },
      productStatus: '',
      modalConfig: {
        showModal: false,
        modalTitle: '',
        modalLabel: '',
        modalOptions: [],
        modalValue: null,
        modalButtonLabel: '',
        modalHideCancelButton: false
      },
      generalHelpWorkflows: [],
      createTicketLoading: false,
      isInvoiceBilled: false,
      loadingModalWorkflows: false,
      openModalAssemblyUrl: false,
      openModalAssemblyHistory: false,
      assemblyOptions: [
        {
          public_label: 'Agendar montagem',
          public_value: 'openAssemblyUrl'
        },
        {
          public_label: 'Meus agendamentos',
          public_value: 'openAssemblyHistory'
        }
      ],
      schedules: []
    }
  },
  computed: {
    assembler: function() {
      return this.schedules[0] ? this.schedules[this.schedules.length - 1].assembler : '--'
    },
    assemblyDate: function() {
      return this.schedules.length ? `${this.schedules[0].date} ás ${this.schedules[0].hour}` : '--:--'
    }
  },

  filters: {
    formatCurrency: value => currencyFormat(value)
  },

  created () {
    this.init()
  },

  beforeMount () {
    this.checkIfNFbilled()
  },
  methods: {
    init () {
      this.productStatus = this.setProductStatus(this.product.lastStatus, this.clusters)

      if (!this.product.assembly.hasInstallation && !this.product.assembly.schedule.length) return
      const scheduleSorted = this.product.assembly.schedule.sort((a, b) => new Date(b.date) - new Date(a.date))
      this.schedules = scheduleSorted.map((schedule) => ({
        date: schedule.date ? new Date(schedule.date).toLocaleDateString('pt-BR') : '--',
        hour: schedule.time ? schedule.time : '--',
        assembler: schedule.assembler ? schedule.assembler : '--',
        status: schedule.status ? schedule.status : '--',
        scheduleDate: schedule.scheduleDate ? dateFormat(schedule.scheduleDate) : '--',
        scheduleTime: schedule.scheduleTime ? schedule.scheduleTime : '--',
        closingType: schedule.closingType ? schedule.closingType : '--'
      }))
    },

    setProductStatus (lastStatus, clusters) {
      const { cluster = '' } = lastStatus
      if (!cluster) return clusters.INVALID
      if (cluster.toUpperCase() === PAYMENT_PENDING && lastStatus.code?.cod !== 'CONFIRMED') return clusters.PAYMENT_PENDING
      if (cluster.toUpperCase() === PAYMENT_NOT_APPROVED) return clusters.PAYMENT_NOT_APPROVED
      if (cluster.toUpperCase() === PAYMENT_REPROVED) return clusters.PAYMENT_REPROVED
      if (cluster.toUpperCase() === IN_PREPARATION_CONFIRMED) return clusters.IN_PREPARATION
      if (cluster.toUpperCase() === IN_PREPARATION_AWAITING) return clusters.IN_PREPARATION
      if (cluster.toUpperCase() === IN_PREPARATION_RESERVED) return clusters.IN_PREPARATION
      if (cluster.toUpperCase() === IN_PREPARATION_BILLED) return clusters.IN_PREPARATION
      if (cluster.toUpperCase() === CANCELED) return clusters.CANCELED
      if (cluster.toUpperCase() === FINISHED) return clusters.FINISHED
      return clusters.IN_PROGRESS
    },

    checkIfNFbilled () {
      const { statuses } = this.product.timelineMos
      const statusLists = statuses.filter(status => status.resumido === 'Produto em preparação')
      const [list] = statusLists

      if (!list) return this.isInvoiceBilled = false

      const timeline = list.list.some(item => item.substatus = 'Seu produto foi conferido e a nota fiscal está disponível')
      this.isInvoiceBilled = timeline
    },

    showButton (clusters, productStatus, button) {
      if (button === 'cancelProduct' && this.isInvoiceBilled) return
      const possibleButtons = {
        [clusters.PAYMENT_PENDING]: ['downloadManual', 'helpAssembly', 'helpGeneral'],
        [clusters.PAYMENT_NOT_APPROVED]: ['downloadManual', 'helpAssembly', 'helpGeneral'],
        [clusters.PAYMENT_REPROVED]: ['downloadManual', 'helpAssembly', 'helpGeneral'],
        [clusters.IN_PREPARATION]: ['downloadManual', 'helpAssembly', 'helpDelivery', 'cancelProduct', 'helpGeneral'],
        [clusters.CANCELED]: ['downloadManual', 'helpAssembly', 'downloadInvoice', 'helpRefund', 'helpGeneral'],
        [clusters.FINISHED]: ['downloadManual', 'helpAssembly', 'downloadInvoice', 'helpNotDelivered', 'helpExchange', 'helpGeneral'],
        [clusters.IN_PROGRESS]: ['downloadManual', 'helpAssembly', 'helpDelivery', 'downloadInvoice', 'helpCancel', 'helpGeneral'],
        [clusters.INVALID]: ['downloadManual', 'helpGeneral']
      }
      return possibleButtons[productStatus].includes(button)
    },

    openManual (manualLink) {
      if (manualLink) {
        window.open(manualLink, '_blank')
      } else {
        this.openModal('downloadManual')
      }
    },

    async openInvoice (invoiceLink) {
      const fileUrl = await getFileS3(invoiceLink.pdf)

      window.open(fileUrl, '_blank')
    },

    async openMoblyFAQ () {
      window.open('https://www.mobly.com.br/auto-atendimento', '_blank')
    },

    resetModalOptions () {
      this.modalConfig = {
        showModal: false,
        modalTitle: '',
        modalLabel: '',
        modalOptions: [],
        modalValue: null,
        modalButtonLabel: '',
        modalHideCancelButton: false
      }
    },

    async openModal (entity = null) {
      if (!entity) return

      this.modalConfig.showModal = true
      this.loadingModalWorkflows = true

      const functions = {
        cancelProduct: this.getCancelProductOptions,
        downloadInvoice: this.getInvoiceOptions,
        downloadManual: this.getManualOptions,
        helpDelivery: this.getDeliveryOptions,
        helpNotDelivered: this.getNotDeliveredOptions,
        helpRefund: this.getRefundOptions,
        helpAssembly: this.getAssemblyOptions,
        helpExchange: this.getExchangeOptions,
        helpCancel: this.getHelpCancelOptions
      }

      const getOptionsFunction = functions[entity]

      const modalConfig = getOptionsFunction(this.workflowsConfig, entity)

      this.modalConfig = modalConfig
      this.loadingModalWorkflows = false
    },

    handleModalClose (value = null) {
      if (value === null) {
        this.resetModalOptions()
        return
      }
      if (value === 'downloadInvoice') {
        this.resetModalOptions()
        this.openInvoice(this.product.invoice)
        return
      }

      if (value === 'openAssemblyUrl') {
        this.resetModalOptions()
        if (!this.product.assembly.hasInstallation) return
        if (!this.product.assembly.schedule_url) {
          this.openModalAssemblyUrl = true
          return
        }
        window.open(this.product.assembly.schedule_url, '_blank')
        return
      }
      if (value === 'openAssemblyHistory') {
        this.resetModalOptions()
        if (!this.product.assembly.hasInstallation) return
        this.openModalAssemblyHistory = true
        return
      }
      if (value === 'openMoblyFAQ') {
        this.openMoblyFAQ()
        return
      }
      this.createTicket({ workflowId: value, product: this.product, productsCount: this.productsCount, orderCod: this.orderCod })
    },

    async createTicket ({ workflowId, product, productsCount, orderCod }) {
      try {
        this.createTicketLoading = true
        const payload = {
          workflowId,
          orderCod,
          orderItemCod: product.id,
          ticketType: productsCount === 1 ? 'order' : 'orderItem',
          customer: {
            document: product.customer.document
          }
        }

        const createTicketResponse = await createTicket(payload)

        const checkAutoPopResponse = await checkAutoPop(createTicketResponse._id)

        if (checkAutoPopResponse && checkAutoPopResponse.redirectTo) {
          window.open(checkAutoPopResponse.redirectTo, '_blank')

          // TODO: Ver feedback para quando o ticket for criado com sucesso. Atualmente exibindo mensagem no próprio modal
          this.modalConfig = this.getPostCreateTicketOptions('autopop')
        } else {
          this.modalConfig = this.getPostCreateTicketOptions('noAutopop')
        }
      } catch (error) {
        this.modalConfig = this.getPostCreateTicketOptions('error', error)
      } finally {
        this.createTicketLoading = false
      }
    },

    getCancelProductOptions (workflowsConfigs, entity) {
      const config = workflowsConfigs.find(workflowConfig => workflowConfig.private_buttonCod === entity)
      if (!config) return null

      const showModal = true
      const modalTitle = 'Cancelar item'
      const modalLabel = config.public_label
      const modalOptions = config.public_isMulti ? config.workflows : []
      const isMulti = config.public_isMulti
      const modalValue = config.public_isMulti || !config.workflows[0] ? null : config.workflows[0].public_value
      const modalButtonLabel = 'Continuar'
      const modalHideCancelButton = false

      return {
        showModal,
        modalTitle,
        modalLabel,
        modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton
      }
    },

    getInvoiceOptions (workflowsConfigs, entity) {
      const config = workflowsConfigs.find(workflowConfig => workflowConfig.private_buttonCod === entity)
      if (!config) return null

      const showModal = true
      const modalTitle = 'Nota fiscal'
      const modalLabel = config.public_label
      const modalOptions = config.public_isMulti ? config.workflows : []
      const isMulti = config.public_isMulti
      const modalValue = config.public_isMulti || !config.workflows[0] ? null : config.workflows[0].public_value
      const modalButtonLabel = 'Continuar'
      const modalHideCancelButton = false

      if (this.product.invoice) {
        const downloadOptions = {
          public_label: 'Baixar Nota fiscal',
          public_value: 'downloadInvoice'
        }
        modalOptions.splice(0, 1, downloadOptions)
      }

      return {
        showModal,
        modalTitle,
        modalLabel,
        modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton
      }
    },

    getManualOptions (workflowsConfigs, entity) {
      const config = workflowsConfigs.find(workflowConfig => workflowConfig.private_buttonCod === entity)
      if (!config) return null

      const showModal = true
      const modalTitle = 'Manual de montagem'
      const modalLabel = config.public_label
      const modalOptions = config.public_isMulti ? config.workflows : []
      const isMulti = config.public_isMulti
      const modalValue = config.public_isMulti || !config.workflows[0] ? null : config.workflows[0].public_value
      const modalButtonLabel = 'Abrir atendimento'
      const modalHideCancelButton = false


      return {
        showModal,
        modalTitle,
        modalLabel,
        modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton
      }
    },

    getDeliveryOptions (workflowsConfigs, entity) {
      const config = workflowsConfigs.find(workflowConfig => workflowConfig.private_buttonCod === entity)
      if (!config) return null

      const showModal = true
      const modalTitle = 'Falar sobre a entrega'
      const modalLabel = config.public_label
      const modalOptions = config.public_isMulti ? config.workflows : []
      const isMulti = config.public_isMulti
      const modalValue = config.public_isMulti || !config.workflows[0] ? null : config.workflows[0].public_value
      const modalButtonLabel = 'Abrir atendimento'
      const modalHideCancelButton = false

      return {
        showModal,
        modalTitle,
        modalLabel,
        modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton
      }
    },

    getNotDeliveredOptions (workflowsConfigs, entity) {
      const config = workflowsConfigs.find(workflowConfig => workflowConfig.private_buttonCod === entity)
      if (!config) return null

      const showModal = true
      const modalTitle = 'Ajuda sobre a entrega'
      const modalLabel = config.public_label
      const modalOptions = config.public_isMulti ? config.workflows : []
      const isMulti = config.public_isMulti
      const modalValue = config.public_isMulti || !config.workflows[0] ? null : config.workflows[0].public_value
      const modalButtonLabel = 'Abrir atendimento'
      const modalHideCancelButton = false

      return {
        showModal,
        modalTitle,
        modalLabel,
        modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton
      }
    },

    getRefundOptions (workflowsConfigs, entity) {
      const config = workflowsConfigs.find(workflowConfig => workflowConfig.private_buttonCod === entity)
      if (!config) return null

      const showModal = true
      const modalTitle = 'Falar sobre reembolso'
      const modalLabel = config.public_label
      const modalOptions = config.public_isMulti ? config.workflows : []
      const isMulti = config.public_isMulti
      const modalValue = config.public_isMulti || !config.workflows[0] ? null : config.workflows[0].public_value
      const modalButtonLabel = 'Abrir atendimento'
      const modalHideCancelButton = false

      return {
        showModal,
        modalTitle,
        modalLabel,
        modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton
      }
    },

    getAssemblyOptions (workflowsConfigs, entity) {
      const config = workflowsConfigs.find(workflowConfig => workflowConfig.private_buttonCod === entity)
      if (!config) return null

      const showModal = true
      const modalTitle = 'Serviço de montagem'
      const modalLabel = config.public_label
      const modalOptions = config.public_isMulti ? config.workflows : []
      const isMulti = config.public_isMulti
      const modalValue = config.public_isMulti || !config.workflows[0] ? null : config.workflows[0].public_value
      const modalButtonLabel = 'Continuar'
      const modalHideCancelButton = false

      return {
        showModal,
        modalTitle,
        modalLabel,
        modalOptions: this.product.assembly.hasInstallation ? this.assemblyOptions.concat(modalOptions) : modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton
      }
    },

    getExchangeOptions (workflowsConfigs, entity) {
      const config = workflowsConfigs.find(workflowConfig => workflowConfig.private_buttonCod === entity)
      if (!config) return null

      const showModal = true
      const modalTitle = 'Troca ou devolução'
      const modalLabel = config.public_label
      const modalOptions = config.public_isMulti ? config.workflows : []
      const isMulti = config.public_isMulti
      const modalValue = config.public_isMulti || !config.workflows[0] ? null : config.workflows[0].public_value
      const modalButtonLabel = 'Continuar'
      const modalHideCancelButton = false

      return {
        showModal,
        modalTitle,
        modalLabel,
        modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton
      }
    },

    getHelpCancelOptions (workflowsConfigs, entity) {
      const config = workflowsConfigs.find(workflowConfig => workflowConfig.private_buttonCod === entity)
      if (!config) return null

      const showModal = true
      const modalTitle = 'Ainda é possível cancelar?'
      const modalLabel = config.public_label
      const modalOptions = config.public_isMulti ? config.workflows : []
      const isMulti = config.public_isMulti
      const modalValue = config.public_isMulti || !config.workflows[0] ? null : config.workflows[0].public_value
      const modalButtonLabel = 'Voltar'
      const modalHideCancelButton = true

      return {
        showModal,
        modalTitle,
        modalLabel,
        modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton
      }
    },

    getPostCreateTicketOptions (type, error = {}) {
      const modalOptions = []
      const isMulti = false
      const modalValue = null
      const modalButtonLabel = 'Voltar'
      const modalHideCancelButton = true
      const CONFLICT_STATUS_CODE = 409
      const isConflictResponse = error.response && error.response.status && error.response.status === CONFLICT_STATUS_CODE
      const messageError = isConflictResponse ? error.response.data.message : `Ocorreu um erro ao abrir o ticket. Tente novamente mais tarde ou entre em contato por telefone. Erro: ${error.message || 'Erro inesperado'}`
      const options = {
        autopop: {
          modalTitle: 'Ticket aberto com sucesso',
          modalLabel: 'Continue o atendimento na janela que foi aberta no seu navegador.'
        },
        noAutopop: {
          modalTitle: 'Ticket aberto com sucesso',
          modalLabel: 'Ticket aberto com sucesso! Em breve você receberá atualizações em seu email.'
        },
        error: {
          modalTitle: 'Erro ao criar ticket',
          modalLabel: messageError
        }
      }
      return {
        modalTitle: options[type].modalTitle,
        modalLabel: options[type].modalLabel,
        modalOptions,
        isMulti,
        modalValue,
        modalButtonLabel,
        modalHideCancelButton,
        showModal: true
      }
    },

    getDeliveryDays (product) {
      if (product.shippingDeliveryDate) return `${dateFormat(product.shippingDeliveryDate)}`
      if (product.shippingDeliveryDays === 1) return `${product.shippingDeliveryDays} dia útil`
      return `${product.shippingDeliveryDays} dias úteis`
    }
  }
}
</script>
